import { useCallback, useState } from "react";

export const useConfirmDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState<(() => void) | null>(null);

  const open = useCallback((action: () => void) => {
    setConfirmAction(() => action);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setConfirmAction(null);
    setIsOpen(false);
  }, []);

  const confirm = useCallback(() => {
    confirmAction?.();
    close();
  }, [confirmAction, close]);

  return { isOpen, open, close, confirm };
};
